<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Work Plan
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="shift"
              :label="this.localForm.shift"
              :items="workShiftOptions"
              color="wplblue0"
              prepend-icon="brightness_medium"
              hint="work shift"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="risk"
              :label="this.localForm.risk"
              :items="workPlanRiskOptions"
              color="wplblue0"
              prepend-icon="priority_high"
              hint="plan risk"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.batch"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="link"
            hint="batch"
            persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :change="updateFormChar()"
            v-model="localForm.key"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="vpn_key"
            hint="work key"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Budget and Plan
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-text-field
            :label="getDetailLink.pt"
            prepend-icon="today"
            hint="approved plan"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            :label="getDetailLink.bt"
            prepend-icon="savings"
            hint="plan budget"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>      
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4 mb-2">
              Planning and Dates
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.dcrt',
                label: dateTypeA(this.getDetailStats.dcrt),
                hint: 'created',
                icon: 'edit_calendar'
                }"
              />
            </v-flex>
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.drev',
                label: dateTypeA(this.getDetailStats.dplan),
                hint: 'review',
                icon: 'event_note'
                }"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.dstr',
                label: dateTypeA(this.getDetailStats.dstr),
                hint: 'plan start',
                icon: 'today'
                }"
              />
            </v-flex>
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.dend',
                label: dateTypeA(this.getDetailStats.dend),
                hint: 'plan end',
                icon: 'event'
                }"
              />
            </v-flex>
          </v-layout>
        </div>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Work Plan Comments
          </div>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.plan"
            label="work plan comment"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="planning risks and opportunities"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
        <div>
          <v-layout row :class="ui.textSubheading">
            <!-- <RiskBarriers/> -->
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import workOptions from "@/data/options/mixins/workOptions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import DatePicker from "@/data/functions/components/DatePicker";
// import Append from "@/data/append/components/Append";
// import AppendReadCard from "@/data/append/components/AppendReadCard";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        risk: "",
        shift: "",
        batch: "",
        key: "",
        plan: ""
      },
      orgForm: {
        risk: "",
        shift: "",
        batch: "",
        key: "",
        plan: ""
      },
      risk: "",
      shift: ""
    };
  },
  beforeMount() {
    this.localForm.risk = this.getDetail.char.risk;
    this.localForm.shift = this.getDetail.char.shift;
    this.localForm.batch = this.getDetail.char.batch;
    this.localForm.key = this.getDetail.char.key;
    this.localForm.plan = this.getDetail.char.plan;

    this.orgForm.risk = this.getDetail.char.risk;
    this.orgForm.shift = this.getDetail.char.shift;
    this.orgForm.batch = this.getDetail.char.batch;
    this.orgForm.key = this.getDetail.char.key;
    this.orgForm.plan = this.getDetail.char.plan;
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    workOptions,
    dateFunctions
  ],
  watch: {
    risk() {
      this.localForm.risk = this.risk;
      this.updateFormChar();
    },
    planDur() {
      this.localForm.planDur = this.planDur;
      this.updateFormChar();
    },
    shift() {
      this.localForm.shift = this.shift;
      this.updateFormChar();
    }
  },
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailChar",
      "getDetailLink",
      "getDetailStats",
      "getCurrentPage"
    ])
  },
  components: {
    DatePicker
    // Append
    // AppendReadCard
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line

      if (
        this.localForm.risk !== this.orgForm.risk &&
        this.localForm.risk !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.risk = this.localForm.risk;
        // basic
        char.risk = this.localForm.risk;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.planDur !== this.orgForm.planDur &&
        this.localForm.planDur !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.planDur = this.localForm.planDur;
        // basic
        char.planDur = this.localForm.planDur;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.plan !== this.orgForm.plan &&
        this.localForm.plan !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.plan = this.localForm.plan;
        // basic
        char.plan = this.localForm.plan;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.shift !== this.orgForm.shift &&
        this.localForm.shift !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.shift = this.localForm.shift;
        // basic
        char.shift = this.localForm.shift;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.batch !== this.orgForm.batch &&
        this.localForm.batch !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.batch = this.localForm.batch;
        // basic
        char.batch = this.localForm.batch;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.key !== this.orgForm.key &&
        this.localForm.key !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.key = this.localForm.key;
        // basic
        char.key = this.localForm.key;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.14, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
